import { Component, Input } from '@angular/core';

import { trackByValue } from '../../../shared/util';
import { PickListItemStatus } from '../../interfaces/picklist.interface';

@Component({
  selector: 'lum-picklist-item-status',
  templateUrl: './picklist-item-status.component.html',
  styleUrls: ['./picklist-item-status.component.scss'],
})
export class PicklistItemStatusComponent {
  @Input()
  statuses :PickListItemStatus[];

  trackByValue = trackByValue;

  get filteredStatus() :PickListItemStatus[] {
    return this.statuses.filter((status) => status !== PickListItemStatus.DISABLED);
  }
}
